import React, { useState, useEffect, useMemo, Fragment } from 'react';
import DataTable from 'react-data-table-component';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';
// ticket no: DGV2-1044 author: thesiyazhagan date: 28-10-2026
import { FaDownload, FaArrowsRotate } from "react-icons/fa6";
// DGV2-1044 end
import * as AWS from 'aws-sdk';
import { configData } from "../../../config/systemconfigurationconstants";
import ConfigureRuleSetSave from './Modal-Dialog/configurerule-save';
import { ToastContainer, toast } from "react-toastify";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useEncryption } from '../../../customHooks/useEncryption';
let getusecaseinfo = []; // keep this, but REMOVE any global "let transformedData = []" you had

const UploadRuleSet = () => {
  const [usecase, setUsecase] = useState("");
  const [usecasename, setUsecasename] = useState("");
  const [client, setClient] = useState("");
  const [clientname, setClientname] = useState("");
  const [clientList, setClientList] = useState([]);
  const [showConfigureRule, setShowConfigureRule] = useState(false);
  const [dotloader, setDotLoader] = useState(false);

  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedUsecase, setSelectedUsecase] = useState('');
  const [selectedClient, setSelectedClient] = useState('');
  const [usecaseError, setUsecaseError] = useState('');
  const [clientError, setClientError] = useState('');
  const [showTable, setShowTable] = useState(false);

  const [selectedVersions, setSelectedVersions] = useState({});
  const [selectedVersionObjects, setSelectedVersionObjects] = useState({});
  const [transformedData, setTransformedData] = useState([]);
  const [modifiedversionjson, setModifiedversionjson] = useState([]);
  const [configiuidata, setConfigiuidata] = useState([]);
  const [configResponseData, setConfigResponseData] = useState();
  const [searchText, setSearchText] = useState("");
  // ticket no: DGV2-1044 author: thesiyazhagan date: 28-10-2026
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // DGV2-1044 end
  const { encrypt, decrypt } = useEncryption();
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return decodeURIComponent(parts.pop().split(';').shift());
    }
    return null;
  };
  useEffect(() => {
    setClient("");
    setUsecase("");
    setShowTable(false);
  }, []);

  useEffect(() => {
    getusecaseinfo = JSON.parse(localStorage.getItem("usecaseInfo"));
  }, []);

  const handleUsecaseChange = (value) => {
    setUsecase(value);
    const sel = JSON.parse(localStorage.getItem("usecaseInfo"))?.find(x => x.UseCaseId == value);
    setSelectedUsecase(sel?.UCSN || "");
    const getClientListUnderSelectedUseCase = sel ? sel.Client : [];
    setClientList(getClientListUnderSelectedUseCase);
    setClient(""); // reset client on usecase change
  };

  const handleclientchange = (e) => {
    setClient(e.target.value);
    const getclientname = clientList.find(x => x.ClientID == e.target.value);
    setSelectedClient(getclientname?.CSN || "");
  };

  // ---- Helpers used by search and column cell rendering ----
  const getTooltipFileName = (row, columnName) => {
    const fileName = row?.[`${columnName}_data`]?.RuleFileName;
    if (!fileName) return '';
    const splitFilename = fileName.split("/");
    return splitFilename[splitFilename.length - 1] || fileName;
  };

  const columnsToSearch = ['Base-Rule-Set', 'ClientwithBase', 'ClientExclusive', 'IncomeRules', 'RuleCondition'];
  // ticket no: DGV2-1044 author: thesiyazhagan date: 28-10-2026
  // The first row holds the "None" entries for every column. We keep it out of
  // the paginated set and re-inject it as the first row of every page, so it is
  // always visible (and sticky on scroll) using the DataTable's own cell layout.
  const noneRow = useMemo(
    () => (transformedData.length > 0 ? transformedData[0] : null),
    [transformedData]
  );
  const versionRows = useMemo(
    () => (transformedData.length > 0 ? transformedData.slice(1) : []),
    [transformedData]
  );
  // ---- Search: matches display text and tooltip file names, case-insensitive ----
  const filteredVersionRows = useMemo(() => {
    const needle = searchText.trim().toLowerCase();
    if (!needle) return versionRows;

    return versionRows.filter(row =>
      columnsToSearch.some(col => {
        const display = (row[col] ?? '').toString().toLowerCase();
        const tooltipName = getTooltipFileName(row, col).toLowerCase();
        return display.includes(needle) || tooltipName.includes(needle);
      })
    );
  }, [searchText, versionRows]);

  // Reset to page 1 whenever the search changes.
  useEffect(() => {
    setCurrentPage(1);
  }, [searchText]);

  // Rows shown on the current page: the pinned None row first, then this page's
  // slice of version rows. Pagination is managed manually so the None row never
  // counts toward the page size and never scrolls out of view across pages.
  const pageData = useMemo(() => {
    const start = (currentPage - 1) * rowsPerPage;
    const pageSlice = filteredVersionRows.slice(start, start + rowsPerPage);
    return noneRow ? [noneRow, ...pageSlice] : pageSlice;
  }, [noneRow, filteredVersionRows, currentPage, rowsPerPage]);
  // DGV2-1044 end
  // ---------------- Lambda: Get Configured Rule Version Info ----------------
  const getconfigRulesetManagement = async () => {
    setModifiedversionjson([]);
    setDotLoader(true);

    let valid = true;
    if (!usecase) { setUsecaseError('Please select a usecase.'); valid = false; } else setUsecaseError('');
    if (!client) { setClientError('Please select a client.'); valid = false; } else setClientError('');
    if (!valid) { setDotLoader(false); return; }

    const lambda = new AWS.Lambda({
      region: configData.LAMBDA_REGION,
      accessKeyId: decrypt(getCookie('ak')),
      secretAccessKey: decrypt(getCookie('sk')),
      // Increase the socket timeout for this client to 5 minutes (300,000 milliseconds)
      httpOptions: {
        timeout: 300000
      }
    });
    // Disable SDK-level retries for all AWS services
    AWS.config.update({
      maxRetries: 0
    });

    const payloadData = {
      Command: configData.GET_CONFIGURED_RULE_VERSION_INFO,
      ClientId: client,
      UseCaseId: usecase,
      SecurityId: "",
      SecurityToken: localStorage.getItem("SecurityToken"),
      EventContextId: "",
      CallerSourceId: "",
      CallerSourceName: ""
    };

    const params = {
      FunctionName: configData.LAMBDA_FUNCTION_NAME1,
      Payload: JSON.stringify(payloadData)
    };

    try {
      const lambdaResponse = await new Promise((resolve, reject) => {
        lambda.invoke(params, (err, data) => (err ? reject(err) : resolve(data)));
      });

      const parsedPayload = JSON.parse(lambdaResponse.Payload.toString());

      if (parsedPayload.statusCode === 200) {
        const parsedBody = JSON.parse(parsedPayload.body);
        const parsedOutput = JSON.parse(parsedBody.Output);
        setConfigResponseData(parsedOutput);

        const ruleColumns = {};
        let maxLength = 0;

        parsedOutput.VersionInfo.forEach((rule, ruleIndex) => {
          const { RuleTypeName, RuleTypeVersionInfo, RuleTypeId } = rule;

          // Fallback RuleTypeId logic
          let finalRuleTypeId = RuleTypeId;
          if (!finalRuleTypeId && Array.isArray(RuleTypeVersionInfo) && RuleTypeVersionInfo.length > 0) {
            finalRuleTypeId = RuleTypeVersionInfo[0].RuleTypeId;
          }
          if (!finalRuleTypeId) {
            finalRuleTypeId = ruleIndex + 1;
          }

          const noneRow = {
            [`${RuleTypeName}`]: 'None',
            [`${RuleTypeName}_isActive`]: RuleTypeVersionInfo === null,
            [`${RuleTypeName}_id`]: `${RuleTypeName}-none`,
            [`${RuleTypeName}_data`]: {
              ExcelRuleVersionInfoId: null,
              IdxVersionInfoId: null,
              RuleTypeId: finalRuleTypeId
            }
          };

          ruleColumns[RuleTypeName] = [noneRow];

          if (Array.isArray(RuleTypeVersionInfo)) {
            const versions = RuleTypeVersionInfo.map(info => ({
              [`${RuleTypeName}`]: `V${info.VersionId} ${info.CreatedOnUTC} ${info.UserName}`,
              [`${RuleTypeName}_isActive`]: info.IsActive === 1,
              [`${RuleTypeName}_id`]: `${RuleTypeName}-${info.VersionId}`,
              [`${RuleTypeName}_data`]: {
                ...info,
                RuleTypeId: info.RuleTypeId,
                RuleFileName: info.RuleFileName
              }
            }));
            ruleColumns[RuleTypeName].push(...versions);
          }

          maxLength = Math.max(maxLength, ruleColumns[RuleTypeName].length);
        });

        const rows = [];
        for (let i = 0; i < maxLength; i++) {
          const row = {};
          Object.keys(ruleColumns).forEach(key => {
            const entry = ruleColumns[key][i];
            if (entry) {
              row[key] = entry[key];
              row[`${key}_isActive`] = entry[`${key}_isActive`];
              row[`${key}_id`] = entry[`${key}_id`];
              row[`${key}_data`] = entry[`${key}_data`];
            } else {
              row[key] = null;
              row[`${key}_isActive`] = false;
              row[`${key}_id`] = `${key}-null-${i}`;
              row[`${key}_data`] = null;
            }
          });
          rows.push(row);
        }

        const autoSelections = {};
        const versionObjects = {};
        const activeTracker = {};

        rows.forEach(row => {
          Object.keys(row).forEach(key => {
            if (key.endsWith('_isActive')) {
              const col = key.replace('_isActive', '');
              if (row[key] === true) {
                if (!autoSelections[col]) {
                  autoSelections[col] = row[`${col}_id`];
                  versionObjects[col] = row[`${col}_data`];
                }
                activeTracker[col] = true;
              }
            }
          });
        });

        Object.keys(ruleColumns).forEach(col => {
          if (!activeTracker[col]) {
            const noneEntry = ruleColumns[col][0];
            autoSelections[col] = noneEntry[`${col}_id`];
            versionObjects[col] = noneEntry[`${col}_data`];
          }
        });

        setTransformedData(rows);
        setSelectedVersions(autoSelections);
        setSelectedVersionObjects(versionObjects);
        setShowTable(true);
      }
    } catch (error) {
      console.error('Error in Lambda call:', error);
    } finally {
      setTimeout(() => setDotLoader(false), 800);
    }
  };

  // ---------------- Radio change ----------------
  const handleRadioChange = (columnName, row) => {
    const selectedId = row[`${columnName}_id`];
    const selectedData = row[`${columnName}_data`];

    setSelectedVersions(prev => ({ ...prev, [columnName]: selectedId }));

    setSelectedVersionObjects(prev => {
      const updated = { ...prev };
      if (selectedData) updated[columnName] = selectedData;
      else delete updated[columnName];

      const versionInfoList = Object.values(updated).map(obj => {
        if (obj && obj.ExcelRuleVersionInfoId !== null) {
          return obj;
        } else {
          return {
            ExcelRuleVersionInfoId: null,
            IdxVersionInfoId: null,
            RuleTypeId: obj?.RuleTypeId || null
          };
        }
      });

      setModifiedversionjson(versionInfoList);
      return updated;
    });
  };

  // ---------------- Columns ----------------
  const getColumnSet = (columnName, label) => [
    {
      name: '',
      cell: row => (
        row[columnName] !== null && row[columnName] !== undefined ? (
          <input
            type="radio"
            name={columnName}
            value={row[`${columnName}_id`]}
            checked={selectedVersions[columnName] === row[`${columnName}_id`]}
            onChange={() => handleRadioChange(columnName, row)}
          />
        ) : null
      ),
      ignoreRowClick: true,
      // ticket no: DGV2-1044 author: thesiyazhagan date: 28-10-2026
      style: { justifyContent: 'center' }
      // DGV2-1044 end
    },
    {
      name: label,
      selector: row => row[columnName],
      sortable: true,
      cell: row =>
        row[columnName] ? (
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={`tooltip-${columnName}-${row[`${columnName}_id`]}`}>
                {getTooltipFileName(row, columnName)}
              </Tooltip>
            }
          >
            <span style={{ cursor: 'pointer' }}>{row[columnName]}</span>
          </OverlayTrigger>
        ) : null
    }
  ];

  const columns = [
    ...getColumnSet('Base-Rule-Set', 'Base Versions'),
    ...getColumnSet('ClientwithBase', 'Client Versions'),
    ...getColumnSet('ClientExclusive', 'Client Exclusive Versions'),
    ...getColumnSet('IncomeRules', 'Income Rules'),
    ...getColumnSet('RuleCondition', 'Rule Condition')
  ];

  // ---------------- Extra Lambdas you already had ----------------
  const ruleConfigForUi = async () => {
    const lambda = new AWS.Lambda({
      region: configData.LAMBDA_REGION,
      accessKeyId: decrypt(getCookie('ak')),
      secretAccessKey: decrypt(getCookie('sk')),
      // Increase the socket timeout for this client to 5 minutes (300,000 milliseconds)
      httpOptions: {
        timeout: 300000
      }
    });
    // Disable SDK-level retries for all AWS services
    AWS.config.update({
      maxRetries: 0
    });

    const payloadData = {
      Command: configData.GET_CONFIG_FOR_UI,
      ClientShortName: selectedClient,
      UseCaseShortName: selectedUsecase
    };

    const params = {
      FunctionName: configData.LAMBDA_FUNCTION_NAME1,
      Payload: JSON.stringify(payloadData)
    };

    try {
      const lambdaResponse = await new Promise((resolve, reject) => {
        lambda.invoke(params, (err, data) => (err ? reject(err) : resolve(data)));
      });

      const parsedPayload = JSON.parse(lambdaResponse.Payload.toString());
      if (parsedPayload.statusCode === 200) {
        const parsedBody = JSON.parse(parsedPayload.body);
        setConfigiuidata(parsedBody);
      }
    } catch (error) {
      console.error('Error in getCurrentRpm:', error);
    }
  };

  const downloadTemplate = (json) => {
    AWS.config.credentials = new AWS.Credentials({
      accessKeyId: decrypt(getCookie('ak')),
      secretAccessKey: decrypt(getCookie('sk'))
    });
    const params = {
      Bucket: json.BucketName,
      Key: json.FileName,
      Expires: 300 // The URL will now expire in 5 minutes (300 seconds) 
    };
    const s3 = new AWS.S3({ region: 'us-east-1' });
    const url = s3.getSignedUrl('getObject', params);
    window.open(url, '_blank');

    toast.success("Downloaded Successfully", {
      position: "bottom-center",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };
  // ticket no: DGV2-1044 author: thesiyazhagan date: 28-10-2026
  // Returns true when the selected object for a column represents "None"
  // (no actual rule file to download).
  const isNoneSelection = (obj) =>
    !obj ||
    (obj.ExcelRuleVersionInfoId === null && obj.IdxVersionInfoId === null) ||
    !obj.RuleFileName;
  const downloadconfigsheet = async () => {
    // Use the versions the user has selected (the active rule set), skipping any
    // column set to "None" (nothing to pass for those).
    const activeRules = Object.entries(selectedVersionObjects)
      .filter(([col, obj]) => col !== "RuleCondition" && !isNoneSelection(obj))
      .map(([, obj]) => ({
        Bucket: obj.RuleFileBucketName,
        FileName: obj.RuleFileName
      }));
    // DGV2-1044 end
    if (activeRules.length > 0) {
      setDotLoader(true);
      const lambda = new AWS.Lambda({
        region: configData.LAMBDA_REGION,
        accessKeyId: decrypt(getCookie('ak')),
        secretAccessKey: decrypt(getCookie('sk')),
        // Increase the socket timeout for this client to 5 minutes (300,000 milliseconds)
        httpOptions: {
          timeout: 300000
        }
      });
      // Disable SDK-level retries for all AWS services
      AWS.config.update({
        maxRetries: 0
      });

      const payloadData = {
        Command: configData.MERGE_RULE_TEMPLATE,
        FileList: activeRules
      };

      const params = {
        FunctionName: configData.LAMBDA_FUNCTION_NAME1,
        Payload: JSON.stringify(payloadData)
      };

      try {
        const lambdaResponse = await new Promise((resolve, reject) => {
          lambda.invoke(params, (err, data) => (err ? reject(err) : resolve(data)));
        });

        const parsedPayload = JSON.parse(lambdaResponse.Payload.toString());
        const parsedBody = JSON.parse(parsedPayload.body);
        if (parsedBody.Status === true) {
          downloadTemplate(parsedBody.Output);
        } else {
          toast.error("Download Failed", { position: "bottom-center", autoClose: 2000, theme: "colored" });
        }
      } catch (error) {
        toast.error("Download Failed", { position: "bottom-center", autoClose: 2000, theme: "colored" });
        console.error('Error in getCurrentRpm:', error);
      } finally {
        setTimeout(() => setDotLoader(false), 800);
      }
    }
  };

  const downloadrulecondition = () => {
    // ticket no: DGV2-1044 author: thesiyazhagan date: 28-10-2026
    // Use the user-selected RuleCondition version; skip if "None" is selected.
    const selectedRuleCondition = selectedVersionObjects["RuleCondition"];
    if (isNoneSelection(selectedRuleCondition)) return;

    const { RuleFileBucketName, RuleFileName } = selectedRuleCondition;
    // DGV2-1044 end
    AWS.config.credentials = new AWS.Credentials({
      accessKeyId: decrypt(getCookie('ak')),
      secretAccessKey: decrypt(getCookie('sk'))
    });
    const params = {
      Bucket: RuleFileBucketName,
      Key: RuleFileName,
      Expires: 300 // The URL will now expire in 5 minutes (300 seconds) 

    };
    const s3 = new AWS.S3({ region: 'us-east-1' });
    const url = s3.getSignedUrl('getObject', params);
    window.open(url, '_blank');
    toast.success("Downloaded Successfully", {
      position: "bottom-center",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  // ---------------- Modal handlers ----------------
  const closeConfigureRule = () => setShowConfigureRule(false);
  const saveConfigureRule = () => setShowConfigureRule(true);
  const handleclosesavepopup = () => closeConfigureRule();
  const handleenabledotloader = () => setDotLoader(true);

  return (
    <Fragment>
      <Alert variant="light">
        <Form>
          <Row>
            <Col sm={5} className='pe-0'>
              <Form.Group as={Row}>
                <Form.Label column sm="3" className='text-end'>
                  Usecase Name<span style={{ color: 'red' }}>*</span>
                </Form.Label>
                <Col sm="9">
                  <Form.Select
                    size="sm"
                    value={usecase}
                    onChange={(e) => {
                      handleUsecaseChange(e.target.value);
                      if (e.target.value) setUsecaseError('');
                    }}
                  >
                    <option value="" disabled>Select Usecase</option>
                    {JSON.parse(localStorage.getItem("usecaseInfo"))?.length > 0 && JSON.parse(localStorage.getItem("usecaseInfo")).map((el) => (
                      <option key={el.UseCaseId} value={el.UseCaseId}>{el.UseCaseName}</option>
                    ))}
                  </Form.Select>
                  {usecaseError && <div style={{ color: 'red', fontSize: '0.8rem' }}>{usecaseError}</div>}
                </Col>
              </Form.Group>
            </Col>

            <Col sm={5} className='ps-0'>
              <Form.Group as={Row}>
                <Form.Label column sm="3" className='text-end'>
                  Client<span style={{ color: 'red' }}>*</span>
                </Form.Label>
                <Col sm="9">
                  <Form.Select
                    size="sm"
                    value={client}
                    onChange={(e) => {
                      handleclientchange(e);
                      if (e.target.value) setClientError('');
                    }}
                  >
                    <option value="">Select Client</option>
                    {clientList.map((option, idx) => (
                      <option key={idx} value={option.ClientID}>{option.ClientName}</option>
                    ))}
                  </Form.Select>
                  {clientError && <div style={{ color: 'red', fontSize: '0.8rem' }}>{clientError}</div>}
                </Col>
              </Form.Group>
            </Col>

            <Col sm={2}>
              <Button
                variant="primary"
                size='sm'
                onClick={() => { getconfigRulesetManagement(); ruleConfigForUi(); }}
              >
                Go
              </Button>
            </Col>
          </Row>
        </Form>
      </Alert>

      {showTable && (
        !dotloader ? (
          <>
            <Row>
              <Col sm={3}>
                <Form.Control
                  size="sm"
                  type="text"
                  placeholder="Search (version text or file name)"
                  value={searchText}
                  onChange={e => setSearchText(e.target.value)}
                />
              </Col>
              <Col sm={9} className='text-end mb-1'>
              {/* ticket no: DGV2-1044 author: thesiyazhagan date: 28-10-2026 */}
                <Button
                  variant="outline-secondary"
                  onClick={getconfigRulesetManagement}
                  disabled={dotloader}
                  className='me-1'
                  size='sm'
                >
                  <FaArrowsRotate /> Refresh
                </Button>
                {/* DGV2-1044 end */}
                <Button
                  variant="outline-success"
                  onClick={() => { downloadconfigsheet(); downloadrulecondition(); }}
                  className='me-1'
                  size='sm'
                >
                  <FaDownload className='bounce-icon' /> Download
                </Button>
                <Button
                  variant="primary"
                  disabled={modifiedversionjson.length === 0}
                  size='sm'
                  onClick={saveConfigureRule}
                >
                  Save
                </Button>
              </Col>
            </Row>

            <Row>
              <Col sm={12}>
                {/* ticket no: DGV2-1044 author: thesiyazhagan date: 28-10-2026 */}
                <div className="rule-set-table-wrapper rule-set-grid">
                  <DataTable
                    columns={columns}
                    data={pageData}
                    dense
                    highlightOnHover
                    pointerOnHover
                    noDataComponent="No matching records found"
                    pagination
                    paginationServer
                    paginationTotalRows={filteredVersionRows.length}
                    paginationPerPage={rowsPerPage}
                    paginationDefaultPage={currentPage}
                    onChangePage={(page) => setCurrentPage(page)}
                    onChangeRowsPerPage={(newPerPage, page) => {
                      setRowsPerPage(newPerPage);
                      setCurrentPage(page);
                    }}
                  />
                </div>
                {/* DGV2-1044 end */}
              </Col>
            </Row>
          </>
        ) : (
          <div
            style={{ marginTop: "20%", marginBottom: "20%" }}
            className="d-flex justify-content-center"
          >
            <div className="loader"></div>
          </div>
        )
      )}

      <ConfigureRuleSetSave
        show={showConfigureRule}
        handleClose={closeConfigureRule}
        modifiedversionjson={modifiedversionjson}
        usecase={usecase}
        client={client}
        configiuidata={configiuidata}
        handleclosesavepopup={handleclosesavepopup}
        getconfigRulesetManagement={getconfigRulesetManagement}
        handleenabledotloader={handleenabledotloader}
      />
      <ToastContainer />
    </Fragment>
  );
};

export default UploadRuleSet;
